import React from "react";

import  Container  from "@mui/material/Container";
import  Grid  from "@mui/material/Grid";
import Box from "@mui/material/Box";

const Partners = () => {
    return (
    <Box px={{  xs: 3, sm: 3, md: 10}} py={ { xs:5 ,sm:5, md: 10  } } marginTop="30px">
        <Container maxWidth="lg">
            <Grid container spacing={ 5 } mb={3} display="flex" alignItems={"center"}>
                <Grid xs={12} sm={4} md={4} mb={3}>
                    <Box display="flex" alignItems={"center"} justifyContent={"center"}><img style={ { width: "70%" } } src="/pinksale.png" alt="pinksale" /></Box>
                </Grid>
                <Grid xs={12} sm={4} md={4} mb={3}>
                    <Box display="flex" alignItems={"center"} justifyContent={"center"}><img  style={ { width: "60%" } } src="/dext.png" alt="dextools" /></Box>
                </Grid>
                <Grid xs={12} sm={4} md={4} mb={3} >
                    <Box display="flex" alignItems={"center"} justifyContent={"center"}><img  style={ { width: "85%" } } src="/bsc.png" alt="bsc" /></Box>
                </Grid>
            </Grid>
        </Container>
    </Box>
    );
}

export default Partners;